export default __webpack_public_path__ + "static/media/amazon.c84fc25a.png";